export default "__VITE_ASSET__B8rR7qg1__"